document.addEventListener('DOMContentLoaded', function() {
  const announcementBars = document.querySelectorAll('.announcement-bar');
  if (announcementBars.length <= 1) return;
  
  let current = 0;
  
  // Ocultar todas excepto la primera
  announcementBars.forEach((bar, i) => {
    bar.style.display = i === 0 ? 'block' : 'none';
  });
  
  // Rotar cada 4 segundos
  setInterval(() => {
    announcementBars[current].style.display = 'none';
    current = (current + 1) % announcementBars.length;
    announcementBars[current].style.display = 'block';
  }, 4000);
});
